var map = {
	"./AdhesionBanner/AdhesionBanner": [
		"PZfl",
		9
	],
	"./AdhesionBanner/AdhesionBanner.js": [
		"PZfl",
		9
	],
	"./AdhesionBanner/AdhesionBanner.scss": [
		"rUZ8",
		7
	],
	"./AdhesionBanner/AdhesionBanner.test": [
		"f+vh",
		9,
		0,
		1
	],
	"./AdhesionBanner/AdhesionBanner.test.js": [
		"f+vh",
		9,
		0,
		1
	],
	"./AdhesionBanner/__snapshots__/AdhesionBanner.test.js.snap": [
		"nxBT",
		7,
		52
	],
	"./AgrofyHeader/AgrofyHeader": [
		"9GQE",
		9
	],
	"./AgrofyHeader/AgrofyHeader.js": [
		"9GQE",
		9
	],
	"./AgrofyHeader/AgrofyHeader.scss": [
		"a/s+",
		7
	],
	"./AgrofyHeader/AgrofyHeader.test": [
		"z+wl",
		9,
		0,
		1
	],
	"./AgrofyHeader/AgrofyHeader.test.js": [
		"z+wl",
		9,
		0,
		1
	],
	"./AgrofyHeader/__snapshots__/AgrofyHeader.test.js.snap": [
		"KkMf",
		7,
		53
	],
	"./AgrofyLogo/AgrofyLogo": [
		"NIxV",
		9,
		32
	],
	"./AgrofyLogo/AgrofyLogo.js": [
		"NIxV",
		9,
		32
	],
	"./AgrofyTVVideoCard/AgrofyTVVideoCard": [
		"ZYBt",
		9
	],
	"./AgrofyTVVideoCard/AgrofyTVVideoCard.js": [
		"ZYBt",
		9
	],
	"./AgrofyTVVideoCard/AgrofyTVVideoCard.scss": [
		"xuyi",
		7
	],
	"./AgrofyTvPromo/AgrofyTvPromo": [
		"/6px",
		9,
		19
	],
	"./AgrofyTvPromo/AgrofyTvPromo.js": [
		"/6px",
		9,
		19
	],
	"./BgImageCard/BgImageCard": [
		"O7wD",
		9
	],
	"./BgImageCard/BgImageCard.js": [
		"O7wD",
		9
	],
	"./BgImageCard/BgImageCard.scss": [
		"jY0I",
		7
	],
	"./BgImageCard/BgImageCard.test": [
		"cmjE",
		9,
		0,
		1
	],
	"./BgImageCard/BgImageCard.test.js": [
		"cmjE",
		9,
		0,
		1
	],
	"./BgImageCard/__snapshots__/BgImageCard.test.js.snap": [
		"NVfz",
		7,
		54
	],
	"./Breadcrumb/Breadcrumb": [
		"zt2u",
		9
	],
	"./Breadcrumb/Breadcrumb.js": [
		"zt2u",
		9
	],
	"./Breadcrumb/Breadcrumb.scss": [
		"Hu5R",
		7
	],
	"./Breadcrumb/Breadcrumb.test": [
		"wa5p",
		9,
		0,
		1
	],
	"./Breadcrumb/Breadcrumb.test.js": [
		"wa5p",
		9,
		0,
		1
	],
	"./Breadcrumb/__snapshots__/Breadcrumb.test.js.snap": [
		"sDB1",
		7,
		55
	],
	"./ButtonAgrofy/ButtonAgrofy": [
		"o02E",
		9
	],
	"./ButtonAgrofy/ButtonAgrofy.js": [
		"o02E",
		9
	],
	"./ButtonAgrofy/ButtonAgrofy.scss": [
		"d23k",
		7
	],
	"./ButtonAgrofy/ButtonAgrofy.test": [
		"2Zsj",
		9,
		0,
		5,
		6
	],
	"./ButtonAgrofy/ButtonAgrofy.test.js": [
		"2Zsj",
		9,
		0,
		5,
		6
	],
	"./ButtonAgrofy/__snapshots__/ButtonAgrofy.test.js.snap": [
		"35Ty",
		7,
		56
	],
	"./Cadena3Widget/Cadena3Widget": [
		"mfsQ",
		9,
		10
	],
	"./Cadena3Widget/Cadena3Widget.js": [
		"mfsQ",
		9,
		10
	],
	"./Cadena3Widget/Cadena3Widget.scss": [
		"8xOY",
		7,
		10
	],
	"./Calendar/Calendar": [
		"y9O4",
		9
	],
	"./Calendar/Calendar.js": [
		"y9O4",
		9
	],
	"./Calendar/Calendar.scss": [
		"Y+Yn",
		7
	],
	"./Calendar/Calendar.test": [
		"7xlN",
		9,
		0,
		1
	],
	"./Calendar/Calendar.test.js": [
		"7xlN",
		9,
		0,
		1
	],
	"./Calendar/__snapshots__/Calendar.test.js.snap": [
		"Bg8P",
		7,
		57
	],
	"./Chip/Chip": [
		"tIiL",
		9,
		33
	],
	"./Chip/Chip.js": [
		"tIiL",
		9,
		33
	],
	"./ConditionalLink/ConditionalLink": [
		"PoBZ",
		9
	],
	"./ConditionalLink/ConditionalLink.js": [
		"PoBZ",
		9
	],
	"./CopyLink/CopyIcon": [
		"ybsI",
		9,
		34
	],
	"./CopyLink/CopyIcon.js": [
		"ybsI",
		9,
		34
	],
	"./CopyLink/CopyLink": [
		"OL/D",
		9,
		29
	],
	"./CopyLink/CopyLink.js": [
		"OL/D",
		9,
		29
	],
	"./CurrencyCard/CurrencyCard": [
		"mply",
		9,
		11
	],
	"./CurrencyCard/CurrencyCard.js": [
		"mply",
		9,
		11
	],
	"./CurrencyCard/CurrencyCard.scss": [
		"OTTq",
		7,
		11
	],
	"./CurrencyCard/CurrencyCard.test": [
		"zWgI",
		9,
		0,
		2
	],
	"./CurrencyCard/CurrencyCard.test.js": [
		"zWgI",
		9,
		0,
		2
	],
	"./CurrencyCard/__snapshots__/CurrencyCard.test.js.snap": [
		"7M3s",
		7,
		58
	],
	"./CustomSelectAgrofy/CustomSelectAgrofy": [
		"8wrX",
		9
	],
	"./CustomSelectAgrofy/CustomSelectAgrofy.js": [
		"8wrX",
		9
	],
	"./CustomSelectAgrofy/CustomSelectAgrofy.scss": [
		"uC2t",
		7
	],
	"./CustomSelectAgrofy/CustomSelectAgrofy.test": [
		"0Bah",
		9,
		0,
		2
	],
	"./CustomSelectAgrofy/CustomSelectAgrofy.test.js": [
		"0Bah",
		9,
		0,
		2
	],
	"./CustomSelectAgrofy/__snapshots__/CustomSelectAgrofy.test.js.snap": [
		"xNPG",
		7,
		59
	],
	"./DailyDollar/DailyDollar": [
		"M19j",
		9
	],
	"./DailyDollar/DailyDollar.js": [
		"M19j",
		9
	],
	"./DailyDollar/DailyDollar.scss": [
		"WtKJ",
		7
	],
	"./DailyDollar/DailyDollar.test": [
		"Ch7s",
		9,
		0,
		1
	],
	"./DailyDollar/DailyDollar.test.js": [
		"Ch7s",
		9,
		0,
		1
	],
	"./DailyDollar/__snapshots__/DailyDollar.test.js.snap": [
		"SCXm",
		7,
		60
	],
	"./DailyQuoteBr/DailyAgricultura": [
		"mPV4",
		9
	],
	"./DailyQuoteBr/DailyAgricultura.js": [
		"mPV4",
		9
	],
	"./DailyQuoteBr/DailyPecuária": [
		"FT1C",
		9
	],
	"./DailyQuoteBr/DailyPecuária.js": [
		"FT1C",
		9
	],
	"./DailyWeather/DailyWeather": [
		"7My5",
		9
	],
	"./DailyWeather/DailyWeather.js": [
		"7My5",
		9
	],
	"./DailyWeather/DailyWeather.scss": [
		"aCtN",
		7
	],
	"./DailyWeather/DailyWeather.test": [
		"LeOE",
		9,
		0,
		1
	],
	"./DailyWeather/DailyWeather.test.js": [
		"LeOE",
		9,
		0,
		1
	],
	"./DailyWeather/__snapshots__/DailyWeather.test.js.snap": [
		"8Pz0",
		7,
		61
	],
	"./DarkModeContext/DarkModeContext": [
		"hvNF",
		9,
		35
	],
	"./DarkModeContext/DarkModeContext.js": [
		"hvNF",
		9,
		35
	],
	"./ForecastCard/ForecastCard": [
		"PLjD",
		9
	],
	"./ForecastCard/ForecastCard.js": [
		"PLjD",
		9
	],
	"./ForecastCard/ForecastCard.scss": [
		"TkBv",
		7
	],
	"./ForecastCard/ForecastCard.test": [
		"a2tV",
		9,
		0,
		2
	],
	"./ForecastCard/ForecastCard.test.js": [
		"a2tV",
		9,
		0,
		2
	],
	"./ForecastCard/__snapshots__/ForecastCard.test.js.snap": [
		"qB4c",
		7,
		62
	],
	"./Graphic/Graphic": [
		"tYil",
		9
	],
	"./Graphic/Graphic.js": [
		"tYil",
		9
	],
	"./Graphic/Graphic.scss": [
		"b4H2",
		7
	],
	"./Graphic/Graphic.test": [
		"+r31",
		9,
		0,
		18,
		30
	],
	"./Graphic/Graphic.test.js": [
		"+r31",
		9,
		0,
		18,
		30
	],
	"./Graphic/__snapshots__/Graphic.test.js.snap": [
		"gGdW",
		7,
		63
	],
	"./HeaderSearchBar/HeaderSearchBar": [
		"Oy2l",
		9,
		12
	],
	"./HeaderSearchBar/HeaderSearchBar.js": [
		"Oy2l",
		9,
		12
	],
	"./HeaderSearchBar/HeaderSearchBar.scss": [
		"Uaxv",
		7,
		12
	],
	"./HeaderSearchBar/HeaderSearchBar.test": [
		"Zan9",
		9,
		0,
		1
	],
	"./HeaderSearchBar/HeaderSearchBar.test.js": [
		"Zan9",
		9,
		0,
		1
	],
	"./HeaderSearchBar/__snapshots__/HeaderSearchBar.test.js.snap": [
		"Yt9H",
		7,
		64
	],
	"./HomePanels/HomePanels": [
		"ODtD",
		9
	],
	"./HomePanels/HomePanels.js": [
		"ODtD",
		9
	],
	"./Icons/AgrofyPayLogo": [
		"UG09",
		9
	],
	"./Icons/AgrofyPayLogo.js": [
		"UG09",
		9
	],
	"./Icons/CortevaLogo": [
		"LFUf",
		9
	],
	"./Icons/CortevaLogo.js": [
		"LFUf",
		9
	],
	"./Icons/EmailIcon": [
		"5F5h",
		9,
		36
	],
	"./Icons/EmailIcon.js": [
		"5F5h",
		9,
		36
	],
	"./Icons/FacebookIcon": [
		"qFv1",
		9,
		37
	],
	"./Icons/FacebookIcon.js": [
		"qFv1",
		9,
		37
	],
	"./Icons/TwitterIcon": [
		"uqhl",
		9,
		38
	],
	"./Icons/TwitterIcon.js": [
		"uqhl",
		9,
		38
	],
	"./Icons/WhatsappIcon": [
		"dHnQ",
		9,
		39
	],
	"./Icons/WhatsappIcon.js": [
		"dHnQ",
		9,
		39
	],
	"./IolLogo/IolLogo": [
		"96DR",
		9
	],
	"./IolLogo/IolLogo.js": [
		"96DR",
		9
	],
	"./IolLogo/IolLogo.scss": [
		"nSqo",
		7
	],
	"./LeadNews/LeadNews": [
		"U/SA",
		9
	],
	"./LeadNews/LeadNews.js": [
		"U/SA",
		9
	],
	"./LeadNews/LeadNews.scss": [
		"auO0",
		7
	],
	"./LeadNews/LeadNews.test": [
		"1eTm",
		9,
		0,
		1
	],
	"./LeadNews/LeadNews.test.js": [
		"1eTm",
		9,
		0,
		1
	],
	"./LeadNews/__snapshots__/LeadNews.test.js.snap": [
		"DeIo",
		7,
		65
	],
	"./Loader/Loader": [
		"WaYT",
		9,
		13
	],
	"./Loader/Loader.js": [
		"WaYT",
		9,
		13
	],
	"./Loader/Loader.scss": [
		"Ojdl",
		7,
		13
	],
	"./LoadingContainer/LoadingContainer": [
		"ScnH",
		9
	],
	"./LoadingContainer/LoadingContainer.js": [
		"ScnH",
		9
	],
	"./MainBreakingNews/MainBreakingNews": [
		"i/so",
		9
	],
	"./MainBreakingNews/MainBreakingNews.js": [
		"i/so",
		9
	],
	"./MainBreakingNews/MainBreakingNews.scss": [
		"033s",
		7
	],
	"./MainBreakingNews/MainBreakingNews.test": [
		"HYx8",
		9,
		0,
		1
	],
	"./MainBreakingNews/MainBreakingNews.test.js": [
		"HYx8",
		9,
		0,
		1
	],
	"./MainBreakingNews/__snapshots__/MainBreakingNews.test.js.snap": [
		"ikD1",
		7,
		66
	],
	"./MainMenu/MainMenu": [
		"p+vv",
		9,
		3,
		9
	],
	"./MainMenu/MainMenu.js": [
		"p+vv",
		9,
		3,
		9
	],
	"./MainMenu/MainMenu.test": [
		"riUM",
		9,
		0,
		3,
		4
	],
	"./MainMenu/MainMenu.test.js": [
		"riUM",
		9,
		0,
		3,
		4
	],
	"./MainMenu/__snapshots__/MainMenu.test.js.snap": [
		"iuTZ",
		7,
		67
	],
	"./MostReaded/MostReaded": [
		"wzuO",
		9,
		22
	],
	"./MostReaded/MostReaded.js": [
		"wzuO",
		9,
		22
	],
	"./MostReaded/MostReaded.scss": [
		"ymtf",
		7,
		45
	],
	"./MostReaded/MostReaded.test": [
		"oT+R",
		9,
		0,
		1
	],
	"./MostReaded/MostReaded.test.js": [
		"oT+R",
		9,
		0,
		1
	],
	"./MostReaded/__snapshots__/MostReaded.test.js.snap": [
		"uOo5",
		7,
		68
	],
	"./MostReadedNew/MostReadedNew": [
		"CyPH",
		9
	],
	"./MostReadedNew/MostReadedNew.js": [
		"CyPH",
		9
	],
	"./MostReadedNew/MostReadedNew.scss": [
		"ZjbI",
		7
	],
	"./MultiSelectAgrofy/MultiSelectAgrofy": [
		"AHdu",
		9
	],
	"./MultiSelectAgrofy/MultiSelectAgrofy.js": [
		"AHdu",
		9
	],
	"./MultiSelectAgrofy/MultiSelectAgrofy.scss": [
		"RsWp",
		7
	],
	"./MultiSelectAgrofy/MultiSelectAgrofy.test": [
		"6uLI",
		9,
		0,
		1
	],
	"./MultiSelectAgrofy/MultiSelectAgrofy.test.js": [
		"6uLI",
		9,
		0,
		1
	],
	"./MultiSelectAgrofy/__snapshots__/MultiSelectAgrofy.test.js.snap": [
		"8pvd",
		7,
		69
	],
	"./NewsAppPromo/NewsAppPromo": [
		"+p2w",
		9,
		23
	],
	"./NewsAppPromo/NewsAppPromo.js": [
		"+p2w",
		9,
		23
	],
	"./NewsIframe/NewsIframe": [
		"EXHO",
		9
	],
	"./NewsIframe/NewsIframe.js": [
		"EXHO",
		9
	],
	"./NewsListCard/NewsListCard": [
		"Et//",
		9,
		8
	],
	"./NewsListCard/NewsListCard.js": [
		"Et//",
		9,
		8
	],
	"./NewsListCard/NewsListCard.scss": [
		"ekPc",
		7,
		46
	],
	"./NewsModal/NewsModal": [
		"ejkp",
		9
	],
	"./NewsModal/NewsModal.js": [
		"ejkp",
		9
	],
	"./NewsModal/NoScrollBehavior": [
		"Uicz",
		9
	],
	"./NewsModal/NoScrollBehavior.js": [
		"Uicz",
		9
	],
	"./NewsPlayerList/NewsPlayerList": [
		"wnRW",
		9
	],
	"./NewsPlayerList/NewsPlayerList.js": [
		"wnRW",
		9
	],
	"./NewsletterCard/NewsletterCard": [
		"YMSK",
		9
	],
	"./NewsletterCard/NewsletterCard.js": [
		"YMSK",
		9
	],
	"./NewsletterCard/NewsletterCard.scss": [
		"bXEb",
		7
	],
	"./NewsletterCard/NewsletterCard.test": [
		"iZEJ",
		9,
		0,
		2
	],
	"./NewsletterCard/NewsletterCard.test.js": [
		"iZEJ",
		9,
		0,
		2
	],
	"./NewsletterCard/__snapshots__/NewsletterCard.test.js.snap": [
		"uvP2",
		7,
		70
	],
	"./NewsletterCardWithInput/NewsletterCardWithInput": [
		"MHUB",
		9
	],
	"./NewsletterCardWithInput/NewsletterCardWithInput.js": [
		"MHUB",
		9
	],
	"./NewsletterCardWithInput/NewsletterCardWithInput.scss": [
		"RvWd",
		7
	],
	"./NewsletterNew/NewsletterNew": [
		"oRl9",
		9,
		17
	],
	"./NewsletterNew/NewsletterNew.js": [
		"oRl9",
		9,
		17
	],
	"./NewsletterNew/windmill.png": [
		"D/MC",
		7,
		17
	],
	"./NewslettersBR/NewslettersBR": [
		"xYnG",
		9
	],
	"./NewslettersBR/NewslettersBR.js": [
		"xYnG",
		9
	],
	"./NewslettersPromo/NewslettersPromo": [
		"j281",
		9,
		14
	],
	"./NewslettersPromo/NewslettersPromo.js": [
		"j281",
		9,
		14
	],
	"./NewslettersPromo/NewslettersPromo.scss": [
		"Jjy+",
		7,
		14
	],
	"./NoFilterData/NoFilterData": [
		"5Lu7",
		9
	],
	"./NoFilterData/NoFilterData.js": [
		"5Lu7",
		9
	],
	"./OpinionCard/OpinionCard": [
		"brdR",
		9,
		15
	],
	"./OpinionCard/OpinionCard.js": [
		"brdR",
		9,
		15
	],
	"./OpinionCard/OpinionCard.scss": [
		"iOOt",
		7,
		15
	],
	"./PaginationAgrofy/Pagination.scss": [
		"b4U3",
		7
	],
	"./PaginationAgrofy/PaginationAgrofy": [
		"6NMI",
		9
	],
	"./PaginationAgrofy/PaginationAgrofy.js": [
		"6NMI",
		9
	],
	"./PaginationAgrofy/PaginationAgrofy.test": [
		"u7uA",
		9,
		0,
		2
	],
	"./PaginationAgrofy/PaginationAgrofy.test.js": [
		"u7uA",
		9,
		0,
		2
	],
	"./PaginationAgrofy/__snapshots__/PaginationAgrofy.test.js.snap": [
		"R8uY",
		7,
		71
	],
	"./PopUpBanner/PopUpBanner": [
		"NBVM",
		9
	],
	"./PopUpBanner/PopUpBanner.js": [
		"NBVM",
		9
	],
	"./PopUpBanner/PopUpBanner.scss": [
		"9ptT",
		7
	],
	"./PopUpBanner/PopUpBanner.test": [
		"mTbn",
		9,
		0,
		1
	],
	"./PopUpBanner/PopUpBanner.test.js": [
		"mTbn",
		9,
		0,
		1
	],
	"./PopUpBanner/__snapshots__/PopUpBanner.test.js.snap": [
		"GfmI",
		7,
		72
	],
	"./PushBanner/PushBanner": [
		"h0Bn",
		9
	],
	"./PushBanner/PushBanner.js": [
		"h0Bn",
		9
	],
	"./QuoteTabs/QuoteTabs": [
		"OspW",
		9
	],
	"./QuoteTabs/QuoteTabs.js": [
		"OspW",
		9
	],
	"./QuoteTabs/QuoteTabs.scss": [
		"izVq",
		7
	],
	"./QuoteTabs/QuoteTabs.test": [
		"1jZm",
		9,
		0,
		1
	],
	"./QuoteTabs/QuoteTabs.test.js": [
		"1jZm",
		9,
		0,
		1
	],
	"./QuoteTabs/__snapshots__/QuoteTabs.test.js.snap": [
		"HDtK",
		7,
		73
	],
	"./RainsTabContent/RainsTabContent": [
		"2QcN",
		9
	],
	"./RainsTabContent/RainsTabContent.js": [
		"2QcN",
		9
	],
	"./RainsTabContent/RainsTabContent.scss": [
		"4grS",
		7
	],
	"./RainsTabContent/RainsTabContent.test": [
		"wH+c",
		9,
		0,
		2
	],
	"./RainsTabContent/RainsTabContent.test.js": [
		"wH+c",
		9,
		0,
		2
	],
	"./RainsTabContent/__snapshots__/RainsTabContent.test.js.snap": [
		"d5kW",
		7,
		74
	],
	"./SelectAgrofy/SelectAgrofy": [
		"C4bN",
		9,
		16
	],
	"./SelectAgrofy/SelectAgrofy.js": [
		"C4bN",
		9,
		16
	],
	"./SelectAgrofy/SelectAgrofy.scss": [
		"7igK",
		7,
		16
	],
	"./SelectAgrofy/SelectAgrofy.test": [
		"0p5/",
		9,
		0,
		5,
		6
	],
	"./SelectAgrofy/SelectAgrofy.test.js": [
		"0p5/",
		9,
		0,
		5,
		6
	],
	"./SelectAgrofy/__snapshots__/SelectAgrofy.test.js.snap": [
		"Q5Jm",
		7,
		75
	],
	"./SignWall/SignWall": [
		"zEj5",
		9,
		31
	],
	"./SignWall/SignWall.js": [
		"zEj5",
		9,
		31
	],
	"./SliderCard/SliderCard": [
		"jN2h",
		9,
		20
	],
	"./SliderCard/SliderCard.js": [
		"jN2h",
		9,
		20
	],
	"./StreamingCard/StreamingCard": [
		"pHhN",
		9
	],
	"./StreamingCard/StreamingCard.js": [
		"pHhN",
		9
	],
	"./StreamingCard/StreamingCard.scss": [
		"8WaK",
		7
	],
	"./Tables/FuturesHistoricalTable/FuturesHistoricalTable": [
		"wlRu",
		9
	],
	"./Tables/FuturesHistoricalTable/FuturesHistoricalTable.js": [
		"wlRu",
		9
	],
	"./Tables/FuturesHistoricalTable/FuturesHistoricalTable.scss": [
		"pnD8",
		7
	],
	"./Tables/FuturesHistoricalTable/FuturesHistoricalTable.test": [
		"l2RE",
		9,
		0,
		2
	],
	"./Tables/FuturesHistoricalTable/FuturesHistoricalTable.test.js": [
		"l2RE",
		9,
		0,
		2
	],
	"./Tables/FuturesHistoricalTable/__snapshots__/FuturesHistoricalTable.test.js.snap": [
		"tzGn",
		7,
		76
	],
	"./Tables/GranosTable/GranosTable": [
		"TWfK",
		9
	],
	"./Tables/GranosTable/GranosTable.js": [
		"TWfK",
		9
	],
	"./Tables/GranosTable/GranosTable.scss": [
		"foMR",
		7
	],
	"./Tables/GranosTable/GranosTable.test": [
		"0wLD",
		9,
		0,
		1
	],
	"./Tables/GranosTable/GranosTable.test.js": [
		"0wLD",
		9,
		0,
		1
	],
	"./Tables/GranosTable/__snapshots__/GranosTable.test.js.snap": [
		"aMp2",
		7,
		77
	],
	"./Tables/GranosTableBR/GranosTableBR": [
		"Y1B6",
		9
	],
	"./Tables/GranosTableBR/GranosTableBR.js": [
		"Y1B6",
		9
	],
	"./Tables/GranosTableResume/GranosTableResume": [
		"z90C",
		9
	],
	"./Tables/GranosTableResume/GranosTableResume.js": [
		"z90C",
		9
	],
	"./Tables/GranosTableResume/GranosTableResume.scss": [
		"+XuA",
		7
	],
	"./Tables/InvernadaTable/InvernadaTable": [
		"lS5v",
		9,
		40
	],
	"./Tables/InvernadaTable/InvernadaTable.js": [
		"lS5v",
		9,
		40
	],
	"./Tables/InvernadaTable/InvernadaTable.test": [
		"5OoI",
		9,
		0,
		2
	],
	"./Tables/InvernadaTable/InvernadaTable.test.js": [
		"5OoI",
		9,
		0,
		2
	],
	"./Tables/InvernadaTable/__snapshots__/InvernadaTable.test.js.snap": [
		"yXyR",
		7,
		78
	],
	"./Tables/LiveStockTable/LiveStockTable": [
		"NQnh",
		9
	],
	"./Tables/LiveStockTable/LiveStockTable.js": [
		"NQnh",
		9
	],
	"./Tables/LiveStockTable/LiveStockTable.scss": [
		"ULd+",
		7
	],
	"./Tables/LiveStockTable/LiveStockTable.test": [
		"iYee",
		9,
		0,
		2
	],
	"./Tables/LiveStockTable/LiveStockTable.test.js": [
		"iYee",
		9,
		0,
		2
	],
	"./Tables/LiveStockTable/__snapshots__/LiveStockTable.test.js.snap": [
		"Hale",
		7,
		79
	],
	"./Tables/PhysicalHistoricalTable/PhysicalHistoricalTable": [
		"+o5B",
		7,
		41
	],
	"./Tables/PhysicalHistoricalTable/PhysicalHistoricalTable.js": [
		"+o5B",
		7,
		41
	],
	"./Tables/TableBoardHistorical/TableBoardHistorical": [
		"HrwT",
		9
	],
	"./Tables/TableBoardHistorical/TableBoardHistorical.js": [
		"HrwT",
		9
	],
	"./Tables/TableBoardHistorical/TableBoardHistorical.scss": [
		"oMRr",
		7
	],
	"./Tables/TableBoardHistorical/TableBoardHistorical.test": [
		"2Ya3",
		9,
		0,
		2
	],
	"./Tables/TableBoardHistorical/TableBoardHistorical.test.js": [
		"2Ya3",
		9,
		0,
		2
	],
	"./Tables/TableBoardHistorical/__snapshots__/TableBoardHistorical.test.js.snap": [
		"bKKM",
		7,
		80
	],
	"./Tables/TableBoardPrices/TableBoardPrices": [
		"lBVf",
		9
	],
	"./Tables/TableBoardPrices/TableBoardPrices.js": [
		"lBVf",
		9
	],
	"./Tables/TableBoardPrices/TableBoardPrices.scss": [
		"PTeU",
		7
	],
	"./Tables/TableBoardPrices/TableBoardPrices.test": [
		"E4la",
		9,
		0,
		2
	],
	"./Tables/TableBoardPrices/TableBoardPrices.test.js": [
		"E4la",
		9,
		0,
		2
	],
	"./Tables/TableBoardPrices/__snapshots__/TableBoardPrices.test.js.snap": [
		"ZsO9",
		7,
		81
	],
	"./Tables/TableCurrenciesResume/CurrenciesResume.scss": [
		"4QCN",
		7
	],
	"./Tables/TableCurrenciesResume/TableCurrenciesResume": [
		"dhpu",
		9
	],
	"./Tables/TableCurrenciesResume/TableCurrenciesResume.js": [
		"dhpu",
		9
	],
	"./Tables/TableCurrencyHistorical/TableCurrencyHistorical": [
		"/+KV",
		9
	],
	"./Tables/TableCurrencyHistorical/TableCurrencyHistorical.js": [
		"/+KV",
		9
	],
	"./Tables/TableCurrencyHistorical/TableCurrencyHistorical.scss": [
		"+kuw",
		7
	],
	"./Tables/TableCurrencyHistorical/TableCurrencyHistorical.test": [
		"rVSR",
		9,
		0,
		2
	],
	"./Tables/TableCurrencyHistorical/TableCurrencyHistorical.test.js": [
		"rVSR",
		9,
		0,
		2
	],
	"./Tables/TableCurrencyHistorical/__snapshots__/TableCurrencyHistorical.test.js.snap": [
		"ymRd",
		7,
		82
	],
	"./Tables/TableDollarAndStocks/TableDollarAndStocks": [
		"ryw6",
		9
	],
	"./Tables/TableDollarAndStocks/TableDollarAndStocks.js": [
		"ryw6",
		9
	],
	"./Tables/TableEconomicHistorical/TableEconomicHistorical": [
		"HYxV",
		9
	],
	"./Tables/TableEconomicHistorical/TableEconomicHistorical.js": [
		"HYxV",
		9
	],
	"./Tables/TableEconomicHistorical/TableEconomicHistorical.scss": [
		"gBEk",
		7
	],
	"./Tables/TableEconomicHistorical/TableEconomicHistorical.test": [
		"f8DC",
		9,
		0,
		2
	],
	"./Tables/TableEconomicHistorical/TableEconomicHistorical.test.js": [
		"f8DC",
		9,
		0,
		2
	],
	"./Tables/TableEconomicHistorical/__snapshots__/TableEconomicHistorical.test.js.snap": [
		"wo4G",
		7,
		83
	],
	"./Tables/TableFutures/TableFutures": [
		"zbzW",
		9
	],
	"./Tables/TableFutures/TableFutures.js": [
		"zbzW",
		9
	],
	"./Tables/TableFutures/TableFutures.scss": [
		"c/RB",
		7
	],
	"./Tables/TableFutures/TableFutures.test": [
		"F0Ym",
		9,
		0,
		2
	],
	"./Tables/TableFutures/TableFutures.test.js": [
		"F0Ym",
		9,
		0,
		2
	],
	"./Tables/TableFutures/__snapshots__/TableFutures.test.js.snap": [
		"4G7L",
		7,
		84
	],
	"./Tables/TableIndexsResume/TableIndexsResume": [
		"2sLO",
		9
	],
	"./Tables/TableIndexsResume/TableIndexsResume.js": [
		"2sLO",
		9
	],
	"./Tables/TableIndexsResume/TableIndexsResume.scss": [
		"CxYl",
		7
	],
	"./Tables/TableLiniersPrices/TableLiniersPrices": [
		"LaAs",
		9
	],
	"./Tables/TableLiniersPrices/TableLiniersPrices.js": [
		"LaAs",
		9
	],
	"./Tables/TableLiniersPrices/TableLiniersPrices.scss": [
		"sb7v",
		7
	],
	"./Tables/TableLiniersPrices/TableLiniersPrices.test": [
		"ZkQG",
		9,
		0,
		2
	],
	"./Tables/TableLiniersPrices/TableLiniersPrices.test.js": [
		"ZkQG",
		9,
		0,
		2
	],
	"./Tables/TableLiniersPrices/__snapshots__/TableLiniersPrices.test.js.snap": [
		"Pqx8",
		7,
		85
	],
	"./Tables/TableOfitialPrices/TableOfitialPrices": [
		"6WoE",
		9
	],
	"./Tables/TableOfitialPrices/TableOfitialPrices.js": [
		"6WoE",
		9
	],
	"./Tables/TableOfitialPrices/TableOfitialPrices.scss": [
		"gsMe",
		7
	],
	"./Tables/TableOfitialPrices/TableOfitialPrices.test": [
		"GjL+",
		9,
		0,
		2
	],
	"./Tables/TableOfitialPrices/TableOfitialPrices.test.js": [
		"GjL+",
		9,
		0,
		2
	],
	"./Tables/TableOfitialPrices/__snapshots__/TableOfitialPrices.test.js.snap": [
		"WunN",
		7,
		86
	],
	"./Tables/TableOption/TableOption": [
		"2IDI",
		9
	],
	"./Tables/TableOption/TableOption.js": [
		"2IDI",
		9
	],
	"./Tables/TableOption/TableOption.scss": [
		"iuS8",
		7
	],
	"./Tables/TableOption/TableOption.test": [
		"M11V",
		9,
		0,
		2
	],
	"./Tables/TableOption/TableOption.test.js": [
		"M11V",
		9,
		0,
		2
	],
	"./Tables/TableOption/__snapshots__/TableOption.test.js.snap": [
		"1JGD",
		7,
		87
	],
	"./Tables/TablePhysical/TablePhysical": [
		"yL0P",
		9
	],
	"./Tables/TablePhysical/TablePhysical.js": [
		"yL0P",
		9
	],
	"./Tables/TablePhysical/TablePhysical.scss": [
		"2GL3",
		7
	],
	"./Tables/TablePhysical/TablePhysical.test": [
		"d8+R",
		9,
		0,
		2
	],
	"./Tables/TablePhysical/TablePhysical.test.js": [
		"d8+R",
		9,
		0,
		2
	],
	"./Tables/TablePhysical/__snapshots__/TablePhysical.test.js.snap": [
		"BqFp",
		7,
		88
	],
	"./Tables/TablePhysicalMarket/TablePhysicalMarket": [
		"lKrA",
		9
	],
	"./Tables/TablePhysicalMarket/TablePhysicalMarket.js": [
		"lKrA",
		9
	],
	"./Tables/TablePhysicalMarket/TablePhysicalMarket.scss": [
		"NBIj",
		7
	],
	"./Tables/TablePhysicalMarket/TablePhysicalMarket.test": [
		"T71d",
		9,
		0,
		2
	],
	"./Tables/TablePhysicalMarket/TablePhysicalMarket.test.js": [
		"T71d",
		9,
		0,
		2
	],
	"./Tables/TablePhysicalMarket/__snapshots__/TablePhysicalMarket.test.js.snap": [
		"J6gF",
		7,
		89
	],
	"./TopBreakingNews/TopBreakingNews": [
		"Uk3G",
		9
	],
	"./TopBreakingNews/TopBreakingNews.js": [
		"Uk3G",
		9
	],
	"./TopBreakingNews/TopBreakingNews.scss": [
		"/dyu",
		7
	],
	"./TopBreakingNews/TopBreakingNews.test": [
		"6ydJ",
		9,
		0,
		1
	],
	"./TopBreakingNews/TopBreakingNews.test.js": [
		"6ydJ",
		9,
		0,
		1
	],
	"./TopBreakingNews/TopBreakingNewsVideo": [
		"4rRR",
		9
	],
	"./TopBreakingNews/TopBreakingNewsVideo.js": [
		"4rRR",
		9
	],
	"./TopBreakingNews/__snapshots__/TopBreakingNews.test.js.snap": [
		"a4VU",
		7,
		90
	],
	"./TopMenu/TopMenu": [
		"elpk",
		9,
		3,
		9
	],
	"./TopMenu/TopMenu.js": [
		"elpk",
		9,
		3,
		9
	],
	"./TopMenu/TopMenu.test": [
		"C+A8",
		9,
		0,
		3,
		4
	],
	"./TopMenu/TopMenu.test.js": [
		"C+A8",
		9,
		0,
		3,
		4
	],
	"./TopMenu/__snapshots__/TopMenu.test.js.snap": [
		"2v75",
		7,
		91
	],
	"./UserContext/UserContext": [
		"S5k6",
		9
	],
	"./UserContext/UserContext.js": [
		"S5k6",
		9
	],
	"./VideoCard/VideoCard": [
		"rttS",
		9
	],
	"./VideoCard/VideoCard.js": [
		"rttS",
		9
	],
	"./VideoCard/VideoCard.scss": [
		"qYR6",
		7
	],
	"./VideoCard/__snapshots__/videoCard.test.js.snap": [
		"cmt9",
		7,
		92
	],
	"./VideoCard/videoCard.test": [
		"6Vac",
		9,
		0,
		1
	],
	"./VideoCard/videoCard.test.js": [
		"6Vac",
		9,
		0,
		1
	],
	"./VideoCardImg/PlayerIcon": [
		"HrCm",
		9
	],
	"./VideoCardImg/PlayerIcon.js": [
		"HrCm",
		9
	],
	"./VideoCardImg/VideoCardImg": [
		"/lcn",
		9
	],
	"./VideoCardImg/VideoCardImg.js": [
		"/lcn",
		9
	],
	"./WatermarkLogo/TableGraphicsWatermarkLogo": [
		"e0dw",
		9
	],
	"./WatermarkLogo/TableGraphicsWatermarkLogo.js": [
		"e0dw",
		9
	],
	"./WatermarkLogo/TableWatermarkLogo": [
		"7EFg",
		9
	],
	"./WatermarkLogo/TableWatermarkLogo.js": [
		"7EFg",
		9
	],
	"./WatermarkLogo/WatermarkLogo.scss": [
		"T8xO",
		7
	],
	"./WeatherCard/WeatherCard": [
		"C8lI",
		9,
		24
	],
	"./WeatherCard/WeatherCard.css": [
		"HDee",
		7,
		51
	],
	"./WeatherCard/WeatherCard.js": [
		"C8lI",
		9,
		24
	],
	"./WeatherModal/WeatherModal": [
		"uxdP",
		9
	],
	"./WeatherModal/WeatherModal.js": [
		"uxdP",
		9
	],
	"./WeatherModal/WeatherModal.scss": [
		"AD8e",
		7
	],
	"./WeatherModal/WeatherModal.test": [
		"dy7q",
		9,
		0,
		1
	],
	"./WeatherModal/WeatherModal.test.js": [
		"dy7q",
		9,
		0,
		1
	],
	"./WeatherModal/__snapshots__/WeatherModal.test.js.snap": [
		"rCYT",
		7,
		93
	],
	"./YoutubeIcon/YoutubeIcon": [
		"awKw",
		9,
		42
	],
	"./YoutubeIcon/YoutubeIcon.js": [
		"awKw",
		9,
		42
	],
	"./fetchGrainData/fetchGrainData": [
		"otpK",
		9
	],
	"./fetchGrainData/fetchGrainData.js": [
		"otpK",
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "pkQV";
module.exports = webpackAsyncContext;